module.exports = __webpack_public_path__ + "static/media/fj.3055dc2b.png";